export type MonetizationEventName =
  | 'monetization_init'
  | 'ad_banner_shown'
  | 'ad_banner_hidden'
  | 'ad_interstitial_shown'
  | 'ad_interstitial_skipped'
  | 'ad_rewarded_requested'
  | 'ad_rewarded_granted'
  | 'ad_rewarded_dismissed'
  | 'ad_rewarded_unavailable'
  | 'shop_opened'
  | 'scores_opened'
  | 'skin_selected'
  | 'skin_purchase_started'
  | 'purchase_completed'
  | 'purchase_cancelled'
  | 'purchase_failed'
  | 'purchases_restored'
  | 'run_revived'
  | 'run_finished'
  | 'score_submitted';

export type MonetizationEventProps = Record<string, string | number | boolean>;

let analyticsEndpoint = '';

export function configureAnalytics(endpoint: string): void {
  analyticsEndpoint = endpoint;
}

export function trackEvent(event: MonetizationEventName, props?: MonetizationEventProps): void {
  if (!analyticsEndpoint || typeof navigator === 'undefined') {
    return;
  }
  try {
    const payload = JSON.stringify({ event, props: props ?? {}, at: Date.now() });
    if (typeof navigator.sendBeacon === 'function') {
      navigator.sendBeacon(analyticsEndpoint, payload);
      return;
    }
    void fetch(analyticsEndpoint, { method: 'POST', body: payload, keepalive: true }).catch(
      () => undefined,
    );
  } catch {
    return;
  }
}
